import { apiUrl, user_access_level, user_entity_uuid, myHeaders_Authorized, myHeaders_Auth_With_Cache_Control, user_Status } from "Api/Api";
// , user_Status_Ver, user_account_level, owner_perms, 
import axios from "axios";

//import UserContext from 'store/UserContext';

import { assembleNickname } from "utils/Helper.js";
// , get_current_unix_stamp
export async function get_user_notifications (use_cache = true) {
  console.log("GetUserInfo get_user_notifications");

  if (!user_Status) {
    console.log(" user not logged in");
    return [];
  }
  
  let tmp_headers = use_cache ? myHeaders_Auth_With_Cache_Control : myHeaders_Authorized;
  
  let params = {
    filter_obj: {
      status_code: {
        eq: 1
      },
      created_time: {
        gte: (Math.floor(Date.now() / 1000) - (10 * 86400)) // previous 10 days
      }
    },
    sort_obj: {
        created_time: 'desc'
    },
    limit: 100
  };
  
  let notifications_response = await axios.get(`${apiUrl}users/${user_entity_uuid}/notifications`, { params, ...tmp_headers });
  
  //return notifications_response.data;
  if (!notifications_response) {
    // network issue
    return [];
  } else {
    return notifications_response.data || [];
  }
}

export async function get_user_info (use_cache = false, update_type = 'all', user_info = null, update_uuid = null) {
  console.log("GetUserInfo get_user_info",use_cache,update_type,user_info,update_uuid);

  if (!user_Status) {
    console.log(" user not logged in");
    return {};
  }

  if (!user_info) {
    user_info = {
      theme: window.localStorage.getItem('theme') || "light",
      last_get_user_info_time: new Date().getTime(), // ms
      organizations: [],
      resident_locations: [],
      favorite_categories: [],
      events: [], // for event admins
      chats: [],
      friends: [],
      admins: [] // so admins can see other admins when they are online
    };
  }  
  
  let tmp_headers = use_cache ? myHeaders_Authorized : myHeaders_Auth_With_Cache_Control;
  
  let user_info_promises = [];
  let tmp_api_promise_identifiers = [];

  // need to get user info
  if (update_type === 'all' || update_type === 'user_info') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info");
  }
  if (update_type === 'all' || update_type === 'user_info_resident_locations') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_resident_locations");
  }
  if (update_type === 'all' || update_type === 'user_info_favorite_categories') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/categories.audience?filter_obj=${encodeURIComponent('{"favorited_time":{"gte":1}}')}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_favorite_categories");
  }
  if (update_type === 'all' || update_type === 'user_info_organizations') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/organizations`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_organizations");
  }
  //user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/groups`, tmp_headers));
  //tmp_api_promise_identifiers.push("user_info_groups");
  if (update_type === 'all' || update_type === 'user_info_events') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/events?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_events");
  }
  if (update_type === 'all' || update_type === 'user_info_chats') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/chats?do_recursive=true&filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"created_time":{"gte":'+(Math.floor(Date.now() / 1000) - 86400)+'}}')}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_chats");
  }
  if (update_type === 'all' || update_type === 'user_info_friends') {
    user_info_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/users.audience?filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"friended_time":{"gte":1}}')}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_friends");
  }
  if (user_access_level === 'admin' && (update_type === 'all' || update_type === 'user_info_admins')) {
    user_info_promises.push(axios.get(`${apiUrl}users?index_field=access_level&filter_string=admin`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_admins");
  }
  if (user_access_level === 'admin' && update_type === 'user_info_admin' && update_uuid) {
    user_info_promises.push(axios.get(`${apiUrl}users/${update_uuid}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_admin");
  }
  if (user_access_level === 'admin' && update_type === 'user_info_friend_admin' && update_uuid) {
    user_info_promises.push(axios.get(`${apiUrl}users/${update_uuid}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_friend_admin");
  }
  if (update_type === 'user_info_friend' && update_uuid) {
    user_info_promises.push(axios.get(`${apiUrl}users/${update_uuid}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_friend");
  }
  if (update_type === 'user_info_chat' && update_uuid) {
    user_info_promises.push(axios.get(`${apiUrl}chats/${update_uuid}`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_chat");
    user_info_promises.push(axios.get(`${apiUrl}chats/${update_uuid}/users`, tmp_headers));
    tmp_api_promise_identifiers.push("user_info_chat_users");
  }
  if (update_type === 'user_info_unfriend' && update_uuid) {
    // simple unfriend action - no API calls required here
    if (user_info.friends[update_uuid]) {
      delete user_info.friends[update_uuid];
    }
  }

  let api_responses = await Promise.all(user_info_promises);

  for (let i = 0; i < api_responses.length; i++) {
    if (tmp_api_promise_identifiers[i] === 'user_info') {
      if (api_responses[i].data.avatar_image_url) {
        let array = api_responses[i].data.avatar_image_url.split("/");
        api_responses[i].data.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
      }
      user_info = {
        ...user_info,
        ...api_responses[i].data
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_resident_locations') {
      user_info = {
        ...user_info,
        resident_locations: api_responses[i].data
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_favorite_categories') {
      user_info = {
        ...user_info,
        favorite_categories: api_responses[i].data
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_organizations') {
      user_info = {
        ...user_info,
        organizations: api_responses[i].data.sort((a, b) => b.entity_name.localeCompare(a.entity_name))
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_groups') {
      user_info = {
        ...user_info,
        groups: api_responses[i].data.sort((a, b) => b.entity_name.localeCompare(a.entity_name))
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_events') {
      user_info = {
        ...user_info,
        events: api_responses[i].data.sort((a, b) => b.entity_name.localeCompare(a.entity_name))
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_chats') {
      // let's put chats into a hash-type object
      let tmp_chats = {};
      api_responses[i].data.forEach( element => {
        tmp_chats[element.entity_uuid] = element;
        // add nicknames to users
        if (tmp_chats[element.entity_uuid].users) {
          tmp_chats[element.entity_uuid].users.forEach( element => {
            element.entity_name = assembleNickname(element);
            if (element.avatar_image_url) {
              let array = element.avatar_image_url.split("/");
              element.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
            }
          });
        }
      })
      user_info = {
        ...user_info,
        chats: tmp_chats
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_chat') {
      // let's try this for one chat
      let tmp_chats = {...user_info.chats};
      tmp_chats[api_responses[i].data.entity_uuid] = api_responses[i].data;
      if (tmp_chats[api_responses[i].data.entity_uuid].status_code === 1) {
        if (tmp_api_promise_identifiers[i+1] === 'user_info_chat_users') {
          tmp_chats[api_responses[i].data.entity_uuid].users = api_responses[i+1].data;
          // add nicknames
          tmp_chats[api_responses[i].data.entity_uuid].users.forEach( element => {
            element.entity_name = assembleNickname(element);
            if (element.avatar_image_url) {
              let array = element.avatar_image_url.split("/");
              element.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
            }
            // also, massage xref data back into main chat obj for logged-in user
            if (element.entity_uuid === user_entity_uuid) {
              tmp_chats[api_responses[i].data.entity_uuid].xref_data = element.xref_data;
            }
          });
        }
      } else {
        delete tmp_chats[api_responses[i].data.entity_uuid];
      }
      user_info = {
        ...user_info,
        chats: tmp_chats
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_friends') {
      // let's put friends into a hash-type object
      let tmp_friends = {};
      api_responses[i].data.forEach( element => {
        // fix avatar image to be small
        if (element.avatar_image_url) {
          let array = element.avatar_image_url.split("/");
          element.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
        }
        tmp_friends[element.entity_uuid] = element;
        // add nickname
        tmp_friends[element.entity_uuid].entity_name = assembleNickname(tmp_friends[element.entity_uuid]);
      });
      user_info = {
        ...user_info,
        friends: tmp_friends
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_friend') {
      // let's try this for one friend
      let tmp_friends = {...user_info.friends};
      tmp_friends[api_responses[i].data.entity_uuid] = api_responses[i].data;
      if (tmp_friends[api_responses[i].data.entity_uuid].status_code === 1) {
        // add nickname
        tmp_friends[api_responses[i].data.entity_uuid].entity_name = assembleNickname(tmp_friends[api_responses[i].data.entity_uuid]);
        if (tmp_friends[api_responses[i].data.entity_uuid].avatar_image_url) {
          let array = tmp_friends[api_responses[i].data.entity_uuid].avatar_image_url.split("/");
          tmp_friends[api_responses[i].data.entity_uuid].adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
        }
        user_info = {
          ...user_info,
          friends: tmp_friends
        };
      } else {
        delete tmp_friends[api_responses[i].data.entity_uuid];
      }
    } else if (tmp_api_promise_identifiers[i] === 'user_info_admins') {
      // let's put friends into a hash-type object
      let tmp_admins = {};
      if (api_responses[i].data.entities) {
        api_responses[i].data.entities.forEach( element => {
          if (element.entity_uuid === user_entity_uuid) {
            // myself - skip
            return;
          }
          if (element.status_code === 1) {
            tmp_admins[element.entity_uuid] = element;
            if (element.avatar_image_url) {
              let array = element.avatar_image_url.split("/");
              element.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
            }
            // add nickname
            tmp_admins[element.entity_uuid].entity_name = assembleNickname(tmp_admins[element.entity_uuid]);
          }
        })
      }
      user_info = {
        ...user_info,
        admins: tmp_admins
      };
    } else if (tmp_api_promise_identifiers[i] === 'user_info_admin') {
      // let's try this for one friend
      let tmp_admins = {...user_info.admins};
      tmp_admins[api_responses[i].data.entity_uuid] = api_responses[i].data;
      if (tmp_admins[api_responses[i].data.entity_uuid].status_code === 1) {
        // add nickname
        tmp_admins[api_responses[i].data.entity_uuid].entity_name = assembleNickname(tmp_admins[api_responses[i].data.entity_uuid]);
        if (tmp_admins[api_responses[i].data.entity_uuid].avatar_image_url) {
          let array = tmp_admins[api_responses[i].data.entity_uuid].avatar_image_url.split("/");
          tmp_admins[api_responses[i].data.entity_uuid].adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
        }
        user_info = {
          ...user_info,
          admins: tmp_admins
        };
      } else {
        delete tmp_admins[api_responses[i].data.entity_uuid];
      }
    } else if (tmp_api_promise_identifiers[i] === 'user_info_friend_admin') {
      // let's try this for one friend
      let tmp_admins = {...user_info.admins};
      let tmp_friends = {...user_info.friends};
      tmp_admins[api_responses[i].data.entity_uuid] = api_responses[i].data;
      tmp_friends[api_responses[i].data.entity_uuid] = api_responses[i].data;
      if (tmp_admins[api_responses[i].data.entity_uuid].status_code === 1) {
        // add nickname
        let nickname = assembleNickname(tmp_admins[api_responses[i].data.entity_uuid]);
        tmp_admins[api_responses[i].data.entity_uuid].entity_name = nickname;
        tmp_friends[api_responses[i].data.entity_uuid].entity_name = nickname;
        if (tmp_admins[api_responses[i].data.entity_uuid].avatar_image_url) {
          let array = tmp_admins[api_responses[i].data.entity_uuid].avatar_image_url.split("/");
          tmp_admins[api_responses[i].data.entity_uuid].adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
          tmp_friends[api_responses[i].data.entity_uuid].adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
        }
        user_info = {
          ...user_info,
          admins: tmp_admins,
          friends: tmp_friends
        };
      } else {
        delete tmp_admins[api_responses[i].data.entity_uuid];
        delete tmp_friends[api_responses[i].data.entity_uuid];
      }
    }
  }
  
  //console.log("GetUserInfo get_user_info",user_info);
  
  return user_info;
}